// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=ChatContextParams|schemaHash=0a38b0d6c4324f5b74f40ba3b4e740c749776177

import { setDefinedValue } from '@myre/common-primitives';

export function parseChatContextParamsFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'customerId', _data.customerId);
  setDefinedValue(result, 'acquisitionId', _data.acquisitionId);
  setDefinedValue(result, 'budgetId', _data.budgetId);
  setDefinedValue(result, 'budgetPlanId', _data.budgetPlanId);
  setDefinedValue(result, 'capexBudgetYear', _data.capexBudgetYear);
  setDefinedValue(result, 'capexPackageId', _data.capexPackageId);
  setDefinedValue(result, 'capexProgramId', _data.capexProgramId);
  setDefinedValue(result, 'consolidationId', _data.consolidationId);
  setDefinedValue(result, 'contractId', _data.contractId);
  setDefinedValue(result, 'corporateId', _data.corporateId);
  setDefinedValue(result, 'covenantId', _data.covenantId);
  setDefinedValue(result, 'debtId', _data.debtId);
  setDefinedValue(result, 'equityId', _data.equityId);
  setDefinedValue(result, 'invoiceId', _data.invoiceId);
  setDefinedValue(result, 'lenderAmountId', _data.lenderAmountId);
  setDefinedValue(result, 'lenderId', _data.lenderId);
  setDefinedValue(result, 'portfolioId', _data.portfolioId);
  setDefinedValue(result, 'propertyChargeId', _data.propertyChargeId);
  setDefinedValue(result, 'propertyId', _data.propertyId);
  setDefinedValue(result, 'tenantGroupId', _data.tenantGroupId);
  setDefinedValue(result, 'tenantId', _data.tenantId);
  setDefinedValue(result, 'trancheId', _data.trancheId);
  setDefinedValue(result, 'trueUpId', _data.trueUpId);
  setDefinedValue(result, 'valuationId', _data.valuationId);

  return result;
}

export function parseChatContextParamsToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'customerId', _data.customerId);
  setDefinedValue(result, 'acquisitionId', _data.acquisitionId);
  setDefinedValue(result, 'budgetId', _data.budgetId);
  setDefinedValue(result, 'budgetPlanId', _data.budgetPlanId);
  setDefinedValue(result, 'capexBudgetYear', _data.capexBudgetYear);
  setDefinedValue(result, 'capexPackageId', _data.capexPackageId);
  setDefinedValue(result, 'capexProgramId', _data.capexProgramId);
  setDefinedValue(result, 'consolidationId', _data.consolidationId);
  setDefinedValue(result, 'contractId', _data.contractId);
  setDefinedValue(result, 'corporateId', _data.corporateId);
  setDefinedValue(result, 'covenantId', _data.covenantId);
  setDefinedValue(result, 'debtId', _data.debtId);
  setDefinedValue(result, 'equityId', _data.equityId);
  setDefinedValue(result, 'invoiceId', _data.invoiceId);
  setDefinedValue(result, 'lenderAmountId', _data.lenderAmountId);
  setDefinedValue(result, 'lenderId', _data.lenderId);
  setDefinedValue(result, 'portfolioId', _data.portfolioId);
  setDefinedValue(result, 'propertyChargeId', _data.propertyChargeId);
  setDefinedValue(result, 'propertyId', _data.propertyId);
  setDefinedValue(result, 'tenantGroupId', _data.tenantGroupId);
  setDefinedValue(result, 'tenantId', _data.tenantId);
  setDefinedValue(result, 'trancheId', _data.trancheId);
  setDefinedValue(result, 'trueUpId', _data.trueUpId);
  setDefinedValue(result, 'valuationId', _data.valuationId);

  return result;
}
